// Rotas da agenda (ver AGENDA.md): calendário para toda a equipe; profissionais só para administradores.
import { frontendURL } from '../../../helper/URLHelper';
import AgendaPage from './pages/AgendaPage.vue';
import AgendaProfessionalsPage from './pages/AgendaProfessionalsPage.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/agenda'),
    name: 'agenda_index',
    component: AgendaPage,
    meta: { permissions: ['administrator', 'agent'] },
  },
  {
    path: frontendURL('accounts/:accountId/agenda/professionals'),
    name: 'agenda_professionals_index',
    component: AgendaProfessionalsPage,
    meta: { permissions: ['administrator'] },
  },
];
